import React from "react";
import {
  getPostableImage,
  getPostableTitle,
  getPostableUrl,
} from "../postable-utils";
import type { PreviewProps } from "../types";

export function WebLinkPreview({ postable, displayType }: PreviewProps) {
  if (postable.postableType !== "webLink") {
    return <div>Not a web link</div>;
  }

  // Get image, title and url using helper functions
  const imageUrl = getPostableImage(postable);
  const title = getPostableTitle(postable);
  const url = getPostableUrl(postable) || "#";

  // Display differently based on the display type
  if (displayType === "horizontal") {
    return (
      <div className="relative rounded-lg overflow-hidden w-full h-[160px] shadow-sm">
        <div
          className="w-full h-full bg-cover bg-center"
          style={{ backgroundImage: `url(${imageUrl})` }}
        />
        <div className="absolute bottom-0 left-0 right-0 bg-black/50 p-2">
          <div className="text-white font-semibold text-center">{title}</div>
        </div>
      </div>
    );
  }

  if (displayType === "vertical") {
    return (
      <div className="flex flex-col rounded-lg overflow-hidden w-full h-[200px] shadow-sm">
        <div
          className="w-full h-[140px] bg-cover bg-center"
          style={{ backgroundImage: `url(${imageUrl})` }}
        />
        <div className="bg-white p-2 flex-1">
          <div className="font-semibold">{title}</div>
          <div className="text-muted-foreground text-xs truncate">{url}</div>
        </div>
      </div>
    );
  }

  if (displayType === "grid") {
    return (
      <div className="relative rounded-lg overflow-hidden w-full aspect-square shadow-sm">
        <div
          className="w-full h-full bg-cover bg-center"
          style={{ backgroundImage: `url(${imageUrl})` }}
        />
        <div className="absolute bottom-0 left-0 right-0 bg-black/50 p-2">
          <div className="text-white font-semibold text-center text-sm">
            {title}
          </div>
        </div>
      </div>
    );
  }

  if (displayType === "horizontal-squares") {
    return (
      <div className="relative rounded-lg overflow-hidden w-[120px] h-[120px] shadow-sm">
        <div
          className="w-full h-full bg-cover bg-center"
          style={{ backgroundImage: `url(${imageUrl})` }}
        />
        <div className="absolute bottom-0 left-0 right-0 bg-black/50 p-1">
          <div className="text-white font-semibold text-center text-xs truncate">
            {title}
          </div>
        </div>
      </div>
    );
  }

  // Default/fallback
  return (
    <div className="flex flex-col items-center justify-center h-full p-6 text-center text-muted-foreground">
      <p>Preview not available for {displayType} display type.</p>
      <p className="text-xs mt-1">WebLink</p>
    </div>
  );
}
